import { useQuery } from 'data-fetching-client';
import { GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID, GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID } from '../queries';

/**
 * Fetch product update details by rollout ID if it exists, otherwise fetch by update ID
 * @param rolloutId - Rollout ID
 * @param updateId - Update ID
 * @returns
 */
export function useFetchProductUpdateDetails(rolloutId, updateId) {
  const {
    data: byRolloutIdData,
    loading: byRolloutIdLoading,
    error: byRolloutIdError
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID, {
    skip: !rolloutId,
    variables: {
      id: rolloutId
    }
  });
  const {
    data: byUpdateIdData,
    loading: byUpdateIdLoading,
    error: byUpdateIdError
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID, {
    skip: Boolean(rolloutId),
    variables: {
      id: updateId
    }
  });
  return {
    data: byRolloutIdData || byUpdateIdData,
    loading: byRolloutIdLoading || byUpdateIdLoading,
    error: byRolloutIdError || byUpdateIdError
  };
}